import { Component, OnInit } from "@angular/core";
import { RouterOutlet } from "@angular/router";

import { version } from "../../package.json";
import { of } from "rxjs";
import { AuthService } from "./core/auth/auth.service";

import { ModuleRegistry } from "ag-grid-community";
import { AllEnterpriseModule, LicenseManager } from "ag-grid-enterprise";
import { environment } from "../environments/environment";
import { CrispService } from "./core/crisp/crisp.service";
import { TelemetryService } from "./core/telemetry/telemetry.service";
import { BaseComponent } from "./_components/base/base.component";

ModuleRegistry.registerModules([AllEnterpriseModule]);

LicenseManager.setLicenseKey(environment.agGridLicenseKey);

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
  imports: [RouterOutlet],
})
export class AppComponent extends BaseComponent implements OnInit {
  constructor(
    private _authService: AuthService,
    private _crispService: CrispService,
    private _telemetryService: TelemetryService
  ) {
    console.log("App Version: " + version);
    super();
  }

  ngOnInit(): void {
    this._crispService.init(environment.crispWebsiteId);
    this._crispService.show();
    this.subscriptions.push(this._telemetryService.trackRouteChanges(), this._telemetryService.trackLongAnimationFrames());
    this.checkForUser();
  }

  private checkForUser(): void {
    // Here the UserManager will check if we already have an authenticated users with the raiseEvent flag set to true it will
    // Update everything for us from the event listening in the Auth Service.
    this.subscriptions.push(of(this._authService.userManager.getUser(true)).subscribe());
  }
}
